module.exports = __webpack_public_path__ + "static/media/14-MyWorld-JeffOtt.404b9518.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/14-MyWorld-JeffOtt.jpg
// module id = 149
// module chunks = 0